"use strict";

export default angular.module("contartemx.administracion.cuentas")
    .controller("DesactivarCuentaContribuyenteCtrl", ($scope, $uibModalInstance, apiCall, mostrarNotificacion, cuenta) => {

        $scope.loading = false;

        $scope.closeModal = (respuesta) => {
            $uibModalInstance.dismiss();
        };

        if (cuenta.EsTitular) {
            $scope.mensaje = 'Tú y todos los usuarios perderán acceso a ella.';
        } else {
            $scope.mensaje = 'Perderás acceso a la cuenta.';
        }

        $scope.desactivarContribuyente = () => {

            $scope.loading = true;

            let datosEnviar = {};
            datosEnviar.CveContribuyente = cuenta.ClaveContribuyente;

            apiCall.post('DesactivarCuentaContribuyente', datosEnviar)
                .then((data) => {
                    if (data.EsError) {
                        $scope.alert = [{ msg: data.Mensaje }];
                    } else {
                        $uibModalInstance.close(data);
                    }
                },
                mostrarNotificacion.error)
                .finally(() => $scope.loading = false);

        };

        $scope.closeModalAlert = index => {  
            $scope.alert.splice(index, 1);
        };

    });
